<template>
  <div class="spinnner-container">
    <div
      v-for="(item, index) in spinnerList"
      :key="index"
      class="spinnner-item-box"
      :style="`transform: ${item.transform}`"
    >
      <div
        class="spinnner-content"
        :style="`background:${item.background};animation:${item.animation}`"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spinnerList: [],
    };
  },
  props: {
    pointNum: Number,
    translateX: Number,
    background: String,
  },
  created() {
    this.generateSpinnerList();
  },
  methods: {
    generateSpinnerList() {
      const spinnerList = [];
      const deltaRotate = 360 / this.pointNum;
      const deltaTime = 1 / this.pointNum;

      for (let i = 0; i < this.pointNum; i++) {
        let rotate = `rotate(${i * deltaRotate}deg)`;
        let translateX = `translateX(${this.translateX}px)`;
        let transform = `${rotate} ${translateX}`;
        let animationDelay = `${1 - i * deltaTime}s`;
        let animation = `1s linear -${animationDelay} infinite normal none running spinner-line-shrink`;

        spinnerList.push({
          transform,
          animation,
          background: this.background,
        });
      }

      this.spinnerList = spinnerList;
    },
  },
};
</script>

<style lang="less" scoped>
.spinnner-container {
  position: absolute;
  width: 0px;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: scale(1);

  .spinnner-item-box {
    position: absolute;
    top: -7px;
    width: 14px;
    height: 14px;
    border-radius: 7px;
    transform-origin: left center;

    .spinnner-content {
      width: 100%;
      height: 100%;
      border-radius: 7px;
      box-shadow: transparent 0px 0px 1px;
      background: var();
    }
  }
}
</style>

<style lang="less">
@keyframes spinner-line-shrink {
  0%,
  25%,
  100% {
    /* minimum scale and opacity */
    transform: scale(0.5);
    opacity: 0.25;
  }
  26% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>